import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Privacy from "./Privacy";
import UserAgreement from "./UserAgreement";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `action-tab-${index}`,
    'aria-controls': `action-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#0d131d',
    position: 'relative',
    minHeight: 200,
  }
}));

export default function FloatingActionButtonZoom() {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    let check = window.location.href.search("tab");
    if (check !== -1) {
      let tab = window.location.href.split("tab")[1];
      tab = tab.replace('=', '');
      tab = parseFloat(tab);
      setValue(tab)
    }

  }, []);

  return (
    <>
      <Helmet>
        <title>Rules</title>

        <link rel="canonical" href="/rules" />
      </Helmet>
      <div>
        <div className={'container ' + classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="action tabs example"
            >
              <Tab className="text-white" label="Privacy Policy" {...a11yProps(0)} />
              <Tab className="text-white" label="User Agreement" {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={'ltr'}>
              <Privacy />
            </TabPanel>
            <TabPanel value={value} index={1} dir={'ltr'}>
              <UserAgreement />
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </>
  );
}
